export const METHOD_NAME = "methodName";
export const DESCRIPTION = "description";
